import { createFileRoute } from '@tanstack/react-router'
import { MediaLibrary } from '~/features/media-library/components/media-library'

export const Route = createFileRoute('/dashboard/media/')({
  component: MediaLibrary,
})
